module.exports = __webpack_public_path__ + "img/sj_fuwu.da7dbea0.jpg";